module.exports = __webpack_public_path__ + "static/gallery-5c6a0a833e79729c24c530c5cc1ab6a7.gif";